import { randomString } from './strings.js';
export function basicUniqueId() {
    const dateString = Date.now().toString(36);
    return dateString + randomString();
}
